export const timesheetStrings = {
  en: {
    timesheet: 'Timesheet Details',
    projectWiseWorkReport: 'Project wise Work details',
    start: 'Start Date',
    end: 'End Date',
    view: 'View',
    download: 'Download',
    selectEmployeePlaceHolder: 'Select Employee',
    addTimesheet: 'Add Timesheet',
    timesheetReport: 'Timesheet Report',
    project: 'Project',
    message: 'Message',
    showReport: 'Show Report',
    unfilledDates: 'Unfilled Dates',
    unfilledDays: 'Unfilled Days',
    totalDays: 'Total Days',
    searchUserPlace: 'Search User Name...',
    fileDownloadSuccess: 'File Downloaded Successfully!',
    date: 'Date',
    descriptions: 'Description',
    startTime: 'Start Time',
    allocatedHours: 'Allocated Hours',
    timesheetHours: 'Timesheet Hours',
    endTime: 'End Time',
    duration: 'Duration',
    durationValidation: 'Duration cannot be more than 4 hours',
    durationMinValidation:
      'Duration must be greater than or equal to 30 minutes',
    durationFormatValidation: 'Invalid duration format.',
    timesheetIgnore: 'Timesheet Ignore People',
    addNew: 'Add new Person',
    addPerson: 'Add Person',
    addTimesheetIgnoreSuccess: 'Person Added Successfully!',
    updateSkillSuccess: 'Person Updated Successfully',
    remark: 'Remark',
    missingTimesheetReport: 'Missing Timesheet Report',
    timesheetMissingHours: 'Timesheet Missing Hours',
    projectName: 'Project Name',
    noTimesheetDataForSelectedFilters:
      'No Timesheet Data Available for Selected Filters',
    clearAllFilters: 'Clear All Filters',
    showingRecordsOf: 'Showing {showing} records of {total}',
    downloadTimesheetViewFirst:
      'Please click View to load timesheet data before downloading.'
  },
  es: {}
}
